// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__290o6","newExpiryDate":"styles_newExpiryDate__1Y4Eu","footer":"styles_footer__1MZ6e"};